import React, { useState, useEffect } from 'react';
import './scrollTopButton.scss';
import icon from '../../assets/icons/up-chevron.png';

const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    setVisible(scrolled > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`scrollTopBtn ${visible ? 'active' : ''}`}
      aria-label="Scroll to top"
    >
      <img src={icon} alt="" aria-hidden="true" className="img-fluid" width={32} height={32} />
    </button>
  );
};

export default ScrollTopButton;
